/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*******************************************!*\
  !*** ./src/js/product-recommendations.js ***!
  \*******************************************/
/*
BG: This function uses the recommended products API by Shopify. We firstly pass over the product ID we want to display recommended on, and then for each result, request the product.card template to get the look.
*/
var recommendedProducts = function recommendedProducts() {
  //determine if the recommendProducts class section is present
  var recommended = document.querySelector('.js-recommended-products');
  var flickityPresent = false; //We planning on using flickity?, we check to see if the inline attribute is present.

  if (recommended.hasAttribute('data-flickity')) {
    flickityPresent = true;
  } //if it is....


  if (!!recommended) {
    //Get the productID from the data attribute
    var productID = parseInt(recommended.getAttribute('data-product-id')); //using that productID, query the recommended products API

    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(productID, "&limit=5")).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var products = _ref.products;

      //with the response, loop through each product.
      if (products.length < 5) {
        recommended.classList.add('hide-arrows');
      }

      products.forEach(function (product, index) {
        //console.log(product.handle)
        //we run a second fetch to get the product card HTML markup
        fetch(window.Shopify.routes.root + "products/".concat(product.handle, "?view=card")).then(function (response) {
          return response.text();
        }).then(function (html) {
          var flickitySlider = recommended.querySelector('.flickity-slider'); //if flickity isn't present, it might be that it's not being used at a particular size, so we drop it in the section anyways.

          if (flickitySlider) {
            flickitySlider.innerHTML += html;
          } else {
            recommended.innerHTML += html;
          } //if last product, and we're using flickity....


          if (index === products.length - 1 && flickityPresent && flickitySlider) {
            //after a breif delay, re-init flickity.
            setTimeout(function () {
              var flkty = Flickity.data('.js-recommended-products');
              flkty.reloadCells();
              flkty.resize();
            }, 1000);
          }
        });
      });
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  }
};

recommendedProducts();
/******/ })()
;